/**
 * Axepta UserData protocol: type-safe builders and parser for the pipe-delimited
 * UserData string that Axepta returns on payment redirects.
 *
 * Format:
 *   BOOKING:        "<affidiumPnr>|<sessionId>"
 *   DEPOSIT:        "deposit|<reference>|<amountCents>"
 *   LEGACY_DEPOSIT: "legacy_deposit|<dossierNumber>|<amountCents>"
 *   INSURANCE:      "insurance|<reference>|<bookingId>|<amountCents>|<sessionId?>"
 */
const SEPARATOR = '|';
export function buildBookingUserData(pnr, sessionId) {
    return [pnr, sessionId].join(SEPARATOR);
}
// ── Parser (frontend) ──
export function buildDepositUserData(reference, amountCents) {
    return ['deposit', reference, String(amountCents)].join(SEPARATOR);
}
export function buildInsuranceUserData(reference, bookingId, amountCents, sessionId) {
    // amountCents à un index FIXE (4e), sessionId optionnel en dernier : évite
    // l'ambiguïté positionnelle du montant quand sessionId est absent.
    const parts = ['insurance', reference, bookingId, String(amountCents)];
    if (sessionId)
        parts.push(sessionId);
    return parts.join(SEPARATOR);
}
export function buildLegacyDepositUserData(dossierNumber, amountCents) {
    return ['legacy_deposit', dossierNumber, String(amountCents)].join(SEPARATOR);
}
export function parsePaymentConfirmationUserData(userData) {
    if (!userData) {
        return { flow: 'unknown' };
    }
    const parts = userData.split(SEPARATOR);
    const [first, second, third, fourth, fifth] = parts;
    // LEGACY_DEPOSIT: "legacy_deposit|<dossierNumber>|<amountCents>"
    if (first === 'legacy_deposit' || first === 'LEGACY_DEPOSIT') {
        return {
            amountCents: parseAmountCents(third),
            bookingRef: second || undefined,
            flow: 'legacy_deposit',
        };
    }
    // DEPOSIT: "deposit|<reference>|<amountCents>"
    if (first === 'deposit' || first === 'DEPOSIT') {
        return {
            amountCents: parseAmountCents(third),
            bookingRef: second || undefined,
            flow: 'deposit',
        };
    }
    // INSURANCE: "insurance|<reference>|<bookingId>|<amountCents>|<sessionId?>"
    if (first === 'insurance' || first === 'INSURANCE') {
        return {
            bookingId: third || undefined,
            sessionId: fifth || undefined,
            amountCents: parseAmountCents(fourth),
            bookingRef: second || undefined,
            flow: 'insurance',
        };
    }
    // BOOKING (checkout): "<affidiumPnr>|<sessionId>"
    return {
        sessionId: second || undefined,
        bookingRef: first || undefined,
        flow: 'booking',
    };
}
function parseAmountCents(value) {
    if (!value)
        return undefined;
    const n = Number(value);
    return Number.isFinite(n) ? n : undefined;
}
